module.exports = __webpack_public_path__ + "img/intro_phone2.7fb6e354.png";